import { Link } from 'react-router-dom';
import { getLatestComics } from '@/mocks/comics';
import ComicCard from '@/components/feature/ComicCard';

export default function LatestUpdateSection() {
  const latestComics = getLatestComics().slice(0, 10);

  return (
    <section className="bg-background-100/70 py-10 md:py-14">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between mb-6 md:mb-8">
          <div>
            <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-900">
              最近更新
            </h2>
            <p className="text-sm text-foreground-500 mt-1">每日更新，精彩不断</p>
          </div>
          <div className="flex items-center gap-3">
            <span className="text-xs text-foreground-500 bg-background-200/70 px-3 py-1.5 rounded-full whitespace-nowrap">
              今日更新 12 部
            </span>
          </div>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-4 md:gap-5">
          {latestComics.map((comic) => (
            <ComicCard
              key={comic.id}
              id={comic.id}
              title={comic.title}
              author={comic.author}
              cover={comic.cover}
              rating={comic.rating}
              views={comic.views}
              chapters={comic.chapters}
              status={comic.status}
              category={comic.category}
              updatedAt={comic.updatedAt}
              tags={comic.tags}
            />
          ))}
        </div>
      </div>
    </section>
  );
}